export const GET_QUERY_CATEGORY = "GET_QUERY_CATEGORY";
export const GET_QUERY_CATEGORY_RESPONSE = "GET_QUERY_CATEGORY_RESPONSE";
export const GET_QUERY_CATEGORY_FAILED = "GET_QUERY_CATEGORY_FAILED";

export const GET_QUERY_SUB_CATEGORY = "GET_QUERY_SUB_CATEGORY";
export const GET_QUERY_SUB_CATEGORY_RESPONSE = "GET_QUERY_SUB_CATEGORY_RESPONSE";
export const GET_QUERY_SUB_CATEGORY_FAILED = "GET_QUERY_SUB_CATEGORY_FAILED";

export const RAISE_QUERY_CLIENT_MF = "RAISE_QUERY_CLIENT_MF";
export const RAISE_QUERY_CLIENT_MF_RESPONSE = "RAISE_QUERY_CLIENT_MF_RESPONSE";
export const RAISE_QUERY_CLIENT_MF_FAILED = "RAISE_QUERY_CLIENT_MF_FAILED";

export const RAISE_QUERY_CLIENT_PMS = "RAISE_QUERY_CLIENT_PMS";
export const RAISE_QUERY_CLIENT_PMS_RESPONSE = "RAISE_QUERY_CLIENT_PMS_RESPONSE";
export const RAISE_QUERY_CLIENT_PMS_FAILED = "RAISE_QUERY_CLIENT_PMS_FAILED";

export const RAISE_QUERY = "RAISE_QUERY";
export const RAISE_QUERY_RESPONSE = "RAISE_QUERY_RESPONSE";
export const RAISE_QUERY_FAILED = "RAISE_QUERY_FAILED";

export const RAISE_QUERY_CLIENT_AIF = "RAISE_QUERY_CLIENT_AIF";
export const RAISE_QUERY_CLIENT_AIF_RESPONSE = "RAISE_QUERY_CLIENT_AIF_RESPONSE";
export const RAISE_QUERY_CLIENT_AIF_FAILED = "RAISE_QUERY_CLIENT_AIF_FAILED";


export const CLIENT_AIF = "CLIENT_AIF";
export const CLIENT_AIF_RESPONSE = "CLIENT_AIF_RESPONSE";
export const CLIENT_AIF_FAILED = "CLIENT_AIF_FAILED";

export const CLIENT_MF = "CLIENT_MF";
export const CLIENT_MF_RESPONSE = "CLIENT_MF_RESPONSE";
export const CLIENT_MF_FAILED = "CLIENT_MF_FAILED";

export const GET_RAISE_QUERY = "GET_RAISE_QUERY";
export const GET_RAISE_QUERY_RESPONSE = "GET_RAISE_QUERY_RESPONSE";
export const GET_RAISE_QUERY_FAILED = "GET_RAISE_QUERY_FAILED";